/*
 * Copyright (c) 2026 CalAmp Corp.  All Rights Reserved
 */
import React from 'react';
import {IconProps} from '../../types/types';
import useIconDLS from '../useIconDLS';

/*
 * Defines the Design Language System (DLS) Column Chooser Icon component.
 */
export const ColumnChooserIcon = (props: IconProps) => {
  const {iconSize, iconColor} = useIconDLS(props);
  return (
    <svg width={iconSize} height={iconSize} viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <line x1='3.75' y1='2.75' x2='3.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='9.75' y1='2.75' x2='9.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='21.75' y1='2.75' x2='21.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
      <line x1='15.75' y1='2.75' x2='15.75' y2='21.25' stroke={iconColor} strokeWidth='1.5' strokeLinecap='round' />
    </svg>
  );
};

export default ColumnChooserIcon;
